import React, { useState } from 'react';
import Alert from '@mui/material/Alert';
import { Input, Button, Table, Card, Spin, message, Row, Col, Space, notification, Tabs, Typography } from 'antd';
import { KeyboardDoubleArrowRightRounded, CloseRounded } from "@mui/icons-material";
import { useTickerSearch } from './hooks'; // Adjust the path as necessary
import SelectedItem from './SelectedItem'; // Adjust the path as necessary
import { isCallable } from "../../utils/typeCheck";
import TickerChip from "../TickerChip"; // Adjust the path as necessary


const { TabPane } = Tabs;

const TickerSearch = ({ onTickersSubmit,
                        closeSearch,
                        types = ['stock', 'etf', 'mf', 'factor'],
                        maxTickers = null,
                        initialSymbols = []
}) => {
  const [filterType, setFilterType] = useState(types.length > 1 ? 'All' : types[0].toLowerCase());
  const {
    tickers, loading, error,
    selectedTickers,
    handleAddOrRemoveTicker,
    handleRemoveTicker,
    debouncedSearchTermUpdate
  } = useTickerSearch({initialSymbols});
  const filteredTickers = tickers.filter(ticker => filterType === 'All' || filterType === ticker.type)
    .sort((a, b) => (b.mktcap || 0) - (a.mktcap || 0));

  const columns = [
    {
      title: 'Security',
      key: 'ticker',
      render: (_, record) => <TickerChip ticker={record} />,
    }
  ];

  const getRowClassName = (record) => {
    return selectedTickers.some(t => t.symbol === record.symbol) ? 'flag--info cursor' : 'cursor';
  }

  const handleSearchChange = (e) => {
    debouncedSearchTermUpdate(e.target.value);
  };

  const handleTypeFilterChange = (key) => {
    console.log(key)
    if (key === 'close'){
      closeSearch?.();
      return;
    }
    setFilterType(key === 'All' ? 'All' : key.toLowerCase());
  };

  const handleAddOrRemoveTickerWithLimit = (ticker) => {
    if (maxTickers !== null && selectedTickers.length >= maxTickers && !selectedTickers.some(t => t.symbol === ticker.symbol)) {
      notification.warning({
        message: 'Maximum Tickers Limit',
        description: `You have reached the maximum limit of ${maxTickers} tickers.`,
      });
      return;
    }
    handleAddOrRemoveTicker(ticker);
  };

  if (error) {
    message.error('Failed to load tickers');
    return null;
  }

  return (
    <Row wrap={false} justify={'center'} align={'top'}>
      <Col flex={'0 0 100px'} style={{padding: '40px 0'}}>
        <Tabs tabPosition="left" defaultActiveKey={filterType} onChange={handleTypeFilterChange}>
          {isCallable(closeSearch) && (
              <TabPane key={'close'} tab={<Typography.Text strong style={{color: 'var(--red)'}}>Close</Typography.Text>}>

              </TabPane>
          )}
            {types.length > 1 && <TabPane tab="ALL" key="All" />}
            {types.map(type => (
              <TabPane tab={type.toUpperCase()} key={type.toUpperCase()} />
            ))}
        </Tabs>
      </Col>
      <Col flex={'0 0 800px'} className={'mx-3'}>
        <Row>
          <Input.Search
            placeholder="Search by Ticker or Name"
            onChange={handleSearchChange}
            size={'large'}
            loading={loading}
            enterButton={
              <Button className={'mx-2'}
                type={'primary'}
                variant={'contained'}
                sx={{ color: "#FFF" }}
                onClick={() => onTickersSubmit(selectedTickers)} disabled={!selectedTickers.length}
                endIcon={<KeyboardDoubleArrowRightRounded />}
              >
                Continue
              </Button>
            }
          />
        </Row>
        <Alert sx={{margin: '16px 0 0 0'}} variant={'text'} color={'info'}>
          Click the rows to select or deselect tickers
        </Alert>

        <Row gutter={[16, 16]} style={{ margin: '8px 0' }}>
          <Col span={24}>
            <Space wrap>
              {selectedTickers.map(ticker => (
                <SelectedItem
                  key={ticker.symbol}
                  ticker={ticker}
                  onRemove={handleRemoveTicker}
                />
              ))}
            </Space>
          </Col>
        </Row>
        {loading ? (
          <Spin size="large" style={{ display: 'block', textAlign: 'center', marginTop: '20px' }} />
        ) : (
          <Table
            columns={columns}
            dataSource={filteredTickers}
            rowClassName={getRowClassName}
            rowKey="symbol"
            pagination={{ pageSize: 25, position: ['bottomLeft'] }}
            scroll={{y: 500}}
            onRow={(record) => ({
              onClick: () => handleAddOrRemoveTickerWithLimit(record),
            })}
          />
        )}
      </Col>

    </Row>
  );
};

export default TickerSearch;
